import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const ChecklistIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path d="M16.375 19L12.825 15.45L14.225 14.05L16.35 16.175L20.6 11.925L22 13.35L16.375 19ZM16.375 11L12.825 7.44999L14.225 6.04999L16.35 8.17499L20.6 3.92499L22 5.34999L16.375 11ZM2 17V15H11V17H2ZM2 8.99999V6.99999H11V8.99999H2Z" />
  </Icon>
)
